import _ from 'lodash';

export function customerArrayFromFg(fgArray: any[]): any[] {
  if(!fgArray) return [];
  const filteredFgArray = fgArray.filter(fg => _.get(fg, 'factoryTicket'));
  const customers = _.map(filteredFgArray, (fg: any) => _.get(fg, 'factoryTicket.order.customer'));
  const filteredCustomers = _.uniqBy(customers, '_id');
  return filteredCustomers;
}